import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import NotFound from "./pages/NotFound";
import './Dashboard.css';
// import Dashboard from './Dashboard';
import Details from './pages/Details';
import Edit from './pages/EditPage';
import MyProfile from './pages/MyProfile';
import List from './pages/List';
import Category from './pages/Category';
import newCustomerManagement from './NewDashboardFiles/CustomerManagement (1)';
import './Dashboard.css';
import ViewCategory from './pages/ViewCategory';
import EditCategory from './pages/EditCategory';
import AddCategory from './pages/AddCategory';
import Employee from './pages/Employee';
import ViewEmployee from './pages/ViewEmployee';
import { format, parseISO } from 'date-fns';
import EditEmployee from './pages/EditEmployee';
import AddEmployee from './pages/AddEmployee';
import AddCustomer from './pages/AddCustomer';
import Customer from './pages/Customer';
import ViewCustomer from './pages/viewCustomer';
import EditCustomer from './pages/EditCustomer';
import Product from './pages/Product';
import AddProduct from './pages/AddProduct';
import CustomerHomePage from './pages/CustomerHomePage';
import ManageEmployeeAccess from './pages/ManageEmployeeAccess';
import WelcomeScreen from './pages/WelcomeScreen';
import Subcategory from './pages/Subcategory';
import AddSubcategory from './pages/AddSubcategory';
import ViewSubcategory from './pages/ViewSubcategory';
import EditSubcategory from './pages/EditSubcategory';
import ViewProduct from './pages/ViewProduct';
import EditProduct from './pages/EditProduct';
import AddMedia from './pages/AddMedia';
import Media from './pages/Media';
import ViewMedia from './pages/ViewMedia';
import EditMedia from './pages/EditMedia';
import AddSlider from './pages/AddSlider';
import Slider from './pages/Slider';
import ViewSlider from './pages/ViewSlider';
import EditSlider from './pages/EditSlider';
import Order from './pages/Order';
import ViewOrder from './pages/ViewOrder';
import Feedback from './pages/Feedback';
import ViewFeedback from './pages/ViewFeedback';
import Module from './pages/Module';
import AddModule from './pages/AddModule';
import ViewModule from './pages/ViewModule';
import EditModule from './pages/EditModule';
import AddProfile from './pages/AddProfile';
import ViewProfile from './pages/ViewProfile';
import EditProfile from './pages/EditProfile';
import Profile from './pages/Profile';
import AddRole from './pages/AddRole';
import ViewRole from './pages/ViewRole';
import EditRole from './pages/EditRole';
import Role from './pages/Role';
import Store from './pages/Store';
import AddStore from './pages/AddStore';
import EditStore from './pages/EditStore';
import ViewStore from './pages/ViewStore';
import Wedget from './pages/Wedget';
import EditWedget from './pages/EditWedget';
import ViewWedget from './pages/ViewWedget';
import Brand from './pages/Brand';
import EditBrand from './pages/EditBrand';
import AddBrand from './pages/addBrand';
import Banner from './pages/Banner';
import AddBanner from './pages/AddBanner';
import EditBanner from './pages/EditBanner';
import Addwidget from './pages/Addwidget';
import ViewBanner from './pages/ViewBanner';
import Scrapping from './pages/Scrapping';
import Blinkit from './pages/Blinkit';
import Zepto from './pages/Zepto';
import Dmart from './pages/Dmart';
import Swiggy from './pages/swiggy';
import Jiomart from './pages/Jiomart';
import BigBasket from './pages/BigBasket';
import Flipkart from './pages/Flipkart';
import Amazon from './pages/Aamazon';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Tag from './pages/Tag';
import AddTag from './pages/AddTag';
import Notification from './pages/notification';
import Addnotification from './pages/Addnotification';
import EditTag from './pages/EditTag';
import Editnotification from './pages/Editnotification';
import ViewNotification from './pages/ViewNotification';             // new page for view notification done by Nandit
import ViewBrand from './pages/ViewBrand';                          // new page for view brand done by Nandit
import ViewTag from './pages/ViewTag';                              // new page for view tag done by Nandit 

function App() {
  const [message, setMessage] = useState(null);
  const location = useLocation(); // for changing the title dynamically done by Nandit

  useEffect(() => {              // for changing the title dynamically from 103 to 109 done by Nandit 
    if (location.pathname === "/") {
      document.title = "Login";
    } else {
      document.title = "Dashboard";
    }
  }, [location]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setMessage(null);
    }, 5000); // 5000 milliseconds = 5 seconds

    return () => clearTimeout(timeoutId);
  }, [message]);

  return (
    <div className='app'>
      <Routes>
        <Route exact path='/' Component={Login} />
        <Route path='/register' Component={Register} />
        <Route path='/forgotPassword' Component={ForgotPassword} />
        <Route path='/not-found' Component={NotFound} />
        <Route path='/details' Component={Details} />
        <Route path='/editPage' Component={Edit} />
        <Route path='/myprofile/:employeeEmailId' Component={MyProfile} />
        <Route path='/Profile' Component={Profile} />
        <Route path='/list' Component={List} />
        {/* <Route path='/dashboard' Component={Dashboard}/> */}
        <Route path='/newCustomerManagement' Component={newCustomerManagement} />
        <Route
          path='/category'
          element={<Category message={message} />}
        />
        <Route path='/viewCategory/:categoryid' Component={ViewCategory} />
        <Route path='/editCategory/:categoryid' element={<EditCategory setMessage={setMessage} />} />
        <Route path='/addCategory' element={<AddCategory setMessage={setMessage} />} />
        <Route path='/employee' Component={Employee} />
        <Route path='/viewEmployee/:employeeEmailId' Component={ViewEmployee} />
        <Route path='/editEmployee/:employeeEmailId' Component={EditEmployee} />
        <Route path='/addEmployee' Component={AddEmployee} />
        <Route path='/addCustomer' Component={AddCustomer} />
        <Route path='/customer' element={<Customer message={message} />} />
        <Route path='/viewCustomer/:customerPhoneNumber' Component={ViewCustomer} />
        <Route path='/editCustomer/:customerPhoneNumber' element={<EditCustomer setMessage={setMessage} />} />
        <Route path='/product' element={<Product message={message} />} />
        <Route path='/addProduct' element={<AddProduct setMessage={setMessage} />} />
        <Route path='/customerHomePage' Component={CustomerHomePage} />
        <Route path='/myProfile' Component={MyProfile} />
        <Route path='/manageEmployeeAccess' Component={ManageEmployeeAccess} />
        <Route path='/subcategory' element={<Subcategory message={message} />} />
        <Route path='/dashboard' Component={WelcomeScreen} />
        <Route path='/addSubcategory' element={<AddSubcategory setMessage={setMessage} />} />
        <Route path='/viewSubcategory/:subcategoryid' Component={ViewSubcategory} />
        <Route path='/editSubcategory/:subcategoryid' element={<EditSubcategory setMessage={setMessage} />} />
        <Route path='/viewProduct/:productid' Component={ViewProduct} />
        <Route path='/editProduct/:productid' element={<EditProduct setMessage={setMessage} />} />
        <Route path='/addMedia' element={<AddMedia setMessage={setMessage} />} />
        <Route path='/addbanner' element={<AddBanner setMessage={setMessage} />} />
        <Route path='/addStore' element={<AddStore setMessage={setMessage} />} />
        <Route path='/addtag' element={<AddTag setMessage={setMessage} />} />
        <Route path='/addnotification' element={<Addnotification setMessage={setMessage} />} />
        <Route path='/media' element={<Media message={message} />} />
        <Route path='/banner' element={<Banner message={message} />} />
        <Route path='/tags' element={<Tag message={message} />} />
        <Route path='/viewtag/:tagid' Component={ViewTag} /> /* new view tag page done by Nandit */
        <Route path='/notification' element={<Notification message={message} />} />
        <Route path='/viewnotification/:notificationid' Component={ViewNotification} /> /* new notification page done by Nandit */
        <Route path='/viewMedia/:mediaid' Component={ViewMedia} />
        <Route path='/viewBanner/:mediaid' Component={ViewBanner} />
        <Route path='/viewStore/:storeid' Component={ViewStore} />
        <Route path='/viewWedget/:id' Component={ViewWedget} />
        <Route path='/editMedia/:mediaid' element={<EditMedia setMessage={setMessage} />} />
        <Route path='/editTag/:id' element={<EditTag setMessage={setMessage} />} />
        <Route path='/EditNotification/:id' element={<Editnotification setMessage={setMessage} />} />
        <Route path='/editBanner/:id' element={<EditBanner setMessage={setMessage} />} />
        <Route path='/editStore/:storeid' element={<EditStore setMessage={setMessage} />} />
        <Route path='/editwedget/:id' element={<EditWedget setMessage={setMessage} />} />
        <Route path='/editbrand/:id' element={<EditBrand setMessage={setMessage} />} />
        <Route path='/addSlider' element={<AddSlider setMessage={setMessage} />} />
        <Route path='/slider' element={<Slider message={message} />} />
        <Route path='/viewSlider/:sliderid' Component={ViewSlider} />
        <Route path='/editSlider/:sliderid' element={<EditSlider setMessage={setMessage} />} />
        <Route path='/order' element={<Order message={message} />} />
        <Route path='/viewOrder/:orderid' Component={ViewOrder} />
        <Route path='/feedback' element={<Feedback message={message} />} />
        <Route path='/stores' element={<Store message={message} />} />
        <Route path='/wedget' element={<Wedget message={message} />} />
        <Route path='/viewFeedback/:feedbackid' Component={ViewFeedback} />
        <Route path='/module' element={<Module message={message} />} />
        <Route path='/addModule' element={<AddModule setMessage={setMessage} />} />
        <Route path='/viewModule/:moduleid' Component={ViewModule} />
        <Route path='/editModule/:moduleid' element={<EditModule setMessage={setMessage} />} />
        <Route path='/addProfile' element={<AddProfile setMessage={setMessage} />} />
        <Route path='/viewProfile/:profileid' Component={ViewProfile} />
        <Route path='/editProfile/:profileid' element={<EditProfile setMessage={setMessage} />} />
        <Route path='/profile' element={<Profile message={message} />} />
        <Route path='/addRole' element={<AddRole setMessage={setMessage} />} />
        <Route path='/viewRole/:roleid' Component={ViewRole} />
        <Route path='/editRole/:roleid' element={<EditRole setMessage={setMessage} />} />
        <Route path='/role' element={<Role message={message} />} />
        <Route path='/brand' element={<Brand message={message} />} />
        <Route path='/viewbrand/:id' Component={ViewBrand} /> /* new brand page done by Nandit */
        <Route path='/comparedetails' element={<Scrapping message={message} />} />
        <Route path='/addbrand' element={<AddBrand setMessage={setMessage} />} />
        <Route path='/addwidget' element={<Addwidget setMessage={setMessage} />} />
        <Route path='/blinkit' element={<Blinkit setMessage={setMessage} />} />
        <Route path='/zepto' element={<Zepto setMessage={setMessage} />} />
        <Route path='/dmart' element={<Dmart setMessage={setMessage} />} />
        <Route path='/swiggy' element={<Swiggy setMessage={setMessage} />} />
        <Route path='/bigBasket' element={<BigBasket setMessage={setMessage} />} />
        <Route path='/jiomart' element={<Jiomart setMessage={setMessage} />} />
        <Route path='/flipkart' element={<Flipkart setMessage={setMessage} />} />
        <Route path='/amazon' element={<Amazon setMessage={setMessage} />} />
      </Routes>
      <ToastContainer />
    </div>
  );
}


export default App;